import { RootState } from 'src/react/root/state/RootState';

export const getQueryString = (state: RootState) => state.routing.locationBeforeTransitions.search;

export const getLocation = (state: RootState) => state.routing.locationBeforeTransitions;
